import Axios from "../helpers/axios";

export const getAllTags = () => {
  return Axios.get(`/tags`);
};

export const addTag = (body) => {
  return Axios.post(`/tags/create`, body);
};
